import { getAxios, postAxios } from "services/api/api.service";
import { apiNames } from "services/api/endpoint.service";

export function getTokenVeridasCall(callback: Function, errorCallback: Function,) {
    const apiWithParams = `/verify/token`;
    getAxios(apiNames.PROFMANAG, true, apiWithParams).then((data: any) => {
      callback(data.data);
    }).catch((error: any) => {
      errorCallback(error)
    })
  }



  export function setSaveDocumentsCall(
      body: any,
      callback: Function,
      errorCallback: Function
    ) {
      postAxios(apiNames.PROFMANAG, true, "/verify/savedata", body)
        .then((data: any) => {
          callback(data);
        })
        .catch((error: any) => {
          errorCallback(error);
        });
    }





